import { z } from 'zod';

const objectId = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid id');

export const ConsentRecordSchema = z.object({
    id: z.string().optional(),
    consent: objectId, // ExplicitConsent ID
    dataSubjectId: z.string().optional(),
    dataSubjectEmail: z.string().optional(),
    dataSubjectName: z.string().optional(),
    dataSubjectType: z.string().optional(),
    given: z.boolean(),
    givenAt: z.string().or(z.date()).optional().nullable(),
    withdrawnAt: z.string().or(z.date()).optional().nullable(),
    expiresAt: z.string().or(z.date()).optional().nullable(),
    source: z.enum(['web', 'mobile', 'paper', 'verbal', 'api']).optional(),
    ipAddress: z.string().optional(),
    userAgent: z.string().optional(),
    consentVersion: z.string().optional(),
    evidenceUrl: z.string().optional(),
    inventoryItemId: objectId.nullable().optional(),
    privacyNoticeId: objectId.nullable().optional(),
    privacyNoticeVersion: z.string().optional(),
    processingPurposeId: objectId.nullable().optional(),
    status: z.enum(['valid', 'withdrawn', 'expired']).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateConsentRecordSchema = ConsentRecordSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateConsentRecordSchema = ConsentRecordSchema.partial();
